module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_5012.a3ff1c75.png";